import { DateTime } from 'luxon';
import { DateControlBase } from '../date-control-base';

const getWeekDateRangeLabel = (date: DateTime) => {
  const start = date.startOf('week').setLocale('nl');
  const end = date.endOf('week').setLocale('nl');
  const monthLabel = end.toFormat('LLL').toLowerCase();
  const yearLabel = end.toFormat('yy');

  if (start.month === end.month) {
    return `${start.day} – ${end.day} ${monthLabel} '${yearLabel}`;
  }
  const startMonthLabel = start.toFormat('LLL').toLowerCase();
  return `${start.day} ${startMonthLabel} – ${end.day} ${monthLabel} '${yearLabel}`;
};

type Props = {
  date: DateTime;
  onChange: (date: DateTime) => void;
  onToday: () => void;
};

export const WeekDateControl = ({ date, onChange, onToday }: Props) => {
  const label = getWeekDateRangeLabel(date);
  const weekNumber = date.toFormat('W');

  return (
    <DateControlBase
      label={label}
      centerLabel={`Week ${weekNumber}`}
      onPrev={() => onChange(date.minus({ weeks: 1 }).startOf('week'))}
      onNext={() => onChange(date.plus({ weeks: 1 }).startOf('week'))}
      onToday={onToday}
      todayPosition="left"
    />
  );
};
